module.exports = __webpack_public_path__ + "img/billet_7.918ff341.jpg";